<div class="grid grid-1col gap p-2">
    <app-check-input
        id="replenishMissing"
        [form]="form"
        [prefix]="prefix"
        [label]="prefix + 'fields.replenishMissing'"
    ></app-check-input>

    @if (!form.value.replenishMissing) {
        <app-number-input
            id="amount"
            [form]="form"
            [prefix]="prefix"
            [min]="1"
        ></app-number-input>
    }
</div>
